import { render } from "./ShippingBillList.vue?vue&type=template&id=5628cb96&scoped=true"
import script from "./ShippingBillList.vue?vue&type=script&lang=js"
export * from "./ShippingBillList.vue?vue&type=script&lang=js"

import "./ShippingBillList.vue?vue&type=style&index=0&id=5628cb96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5628cb96"]])

export default __exports__